import React, { useState } from 'react';
import { addProduct } from '../../services/productService/productService';
import './AddProduct.css';

const AddProduct = ({ onProductAdded }) => {
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    specs: '',
    image: '',
    category: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addProduct(formData);
      alert('Product added successfully!');
      setFormData({
        name: '',
        description: '',
        specs: '',
        image: '',
        category: '',
      });
      if (onProductAdded) onProductAdded();
    } catch (error) {
      alert('Failed to add product. Please try again.');
    }
  };

  return (
    <form onSubmit={handleSubmit} className="add-product-form">
      <h3 className="form-title">Add New Product</h3>
      <input
        type="text"
        name="name"
        placeholder="Name"
        value={formData.name}
        onChange={handleChange}
        required
        className="form-input"
      />
      <input
        type="text"
        name="description"
        placeholder="Description"
        value={formData.description}
        onChange={handleChange}
        required
        className="form-input"
      />
      <input
        type="text"
        name="specs"
        placeholder="Specs"
        value={formData.specs}
        onChange={handleChange}
        required
        className="form-input"
      />
      <input
        type="text"
        name="image"
        placeholder="Image URL"
        value={formData.image}
        onChange={handleChange}
        required
        className="form-input"
      />
      <select
        name="category"
        value={formData.category}
        onChange={handleChange}
        required
        className="form-input"
      >
        <option value="">Select Category</option>
        <option value="PVC Cable Extruder">PVC Cable Extruder</option>
        <option value="PVC Compound Machine">PVC Compound Machine</option>
        <option value="PVC Mixture">PVC Mixture</option>
        <option value="Stranding Machine">Stranding Machine</option>
        <option value="Armouring Machine">Armouring Machine</option>
        <option value="Core-Laying Machine">Core-Laying Machine</option>
        <option value="Copper Buncher">Copper Buncher</option>
        <option value="Take-Ups">Take-Ups</option>
        <option value="Pay-Offs">Pay-Offs</option>
        <option value="Coiling Machines">Coiling Machines</option>
      </select>
      <button type="submit" className="form-button">Add Product</button>
    </form>
  );
};

export default AddProduct;
